export function missingTranslationToReadable(key: string | undefined | null): string {
  if (!key) {
    return '';
  }

  const withoutUnderscore = key.replace(/_/g, ' ');
  return withoutUnderscore.charAt(0).toUpperCase() + withoutUnderscore.slice(1);
}
